
















































































import {
  Component, mixins, mapState, Provide, Watch,
} from '@samclick-commons';

import SamclickMixins from '@/utils/mixins';
import {
  CommonsStore,
  Payload,
  PlayersStore,
  MyaaffiliateStore,
  AuthorizationStore,
} from '@samclick-store-factory';
import {
  formatDate, getStartOfCurrentMonth, getDateTodayIsoFormat, parseStringToDate,
} from '@/utils/date-utils';
import { toMoney } from '@/utils/common-utils';
import PlayersContent from '@/views/Reports/Players/PlayersContent.vue';
import CountryStore from "@/state/modules/country";

class PlayersState {
  displayColumns: Array<string> = []

  public activeTab: string = ''

    public subUsername: string = ''

  public casino: string | number = ''

    public country: string | number = ''

    public displayDate: Array<string> = [getStartOfCurrentMonth(), getDateTodayIsoFormat()]

    public isExporting: Boolean = false
}

@Component({
  /**
   * Imported components
   * */
  components: { PlayersContent },
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      loading: (state: any) => state.players.playersStore.loading,
      players: (state: any) => state.players.playersStore.players,
      playerCountry:  (state: any) => state.commons.commonsStore.playerCountry,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class Players extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new PlayersState();

    payloadTemp = {}

    activeCasinos: { id: number, code: string }[] = []

    @Provide()
    readonly DATE_COLUMN = 'date'

    @Provide()
    readonly USERNAME_COLUMN = 'username'

    @Provide()
    readonly LEVEL_COLUMN = 'level'

    @Provide()
    readonly PLAYER_ID_COLUMN = 'player.system_player_id'

    @Provide()
    readonly SIGNUP_COLUMN = 'signups'

    @Provide()
    readonly FTD_COLUMN = 'ftds'

    @Provide()
    readonly NGR_COLUMN = 'sales'

    @Provide()
    readonly DEPOSITS_COLUMN = 'deposits'

    @Provide()
    readonly WITHDRAWALS_COLUMN = 'withdrawals'

    @Provide()
    readonly COMMISSION_COLUMN = 'commission'

    @Provide()
    readonly TIER_COMMISSION_COLUMN = 'tier_commission'


  /**
   * Watchers
   * */

    /**
     * Methods
     * */
    @Provide()
    submitSearch() {
      return false; // remove when ready
      const {
        displayDate,
        subUsername,
        casino,
      } = this.state;

      const noOfDays = parseStringToDate(displayDate[1]).diff(parseStringToDate(displayDate[0]), 'days');

      if (noOfDays > 31) {
        this.showAlert(this.$t('players.err_max_range').toString(), this.$data.SamclickAlert.ERROR);
        this.state.isExporting = false;
        return false;
      }

      const payload = {
        start_date: displayDate[0],
        end_date: `${formatDate(displayDate[1])}T00:00:00.000Z`,
        subaffiliate_username: subUsername,
        casino,
      };
      this.payloadTemp = payload;
      PlayersStore.getPlayerSales(new Payload(payload)).then((response) => {
        const data = response.data || [];
        const active = data[0].casino_id.toString();
        this.state.activeTab = active;
        this.state.tabLoader = false;
        this.state.showContent = true;
      });

      return true;
    }

    reset() {
      this.state = new PlayersState();
      this.submitSearch();
    }


    exportCsv() {
      this.state.isExporting = true
      const {
        displayDate,
        subUsername,
        casino,
        country,
      } = this.state;

      const noOfDays = parseStringToDate(displayDate[1]).diff(parseStringToDate(displayDate[0]), 'days');

      if (noOfDays > 31) {
        this.showAlert(this.$t('players.err_max_range').toString(), this.$data.SamclickAlert.ERROR);
        this.state.isExporting = false;
        return false;
      }

      let casino_ids: (string | number)[] = []
      if (casino !== 0 && casino !== '') {
        casino_ids = [casino]
      } else {
        casino_ids = this.activeCasinos.map((casino) => casino.id);
      }

      const payload = {
        start_date: displayDate[0],
        end_date: `${formatDate(displayDate[1])}T00:00:00.000Z`,
        subaffiliate_username: subUsername,
        casinos: casino_ids,
        country,
        headers: [
          this.$t('label.date'),
          this.$t('label.player_id'),
          this.$t('forms.country'),
          this.$t('label.signups'),
          this.$t('label.ftds'),
          this.$t('label.ftd_amount'),
          this.$t('label.net_revenue'),
          this.$t('label.deposits'),
          this.$t('label.withdrawals'),
          this.$t('label.commissions'),
          this.$t('label.wagers'),
        ],
      };

      PlayersStore.exportPlayerReports(new Payload(payload)).finally(() => {
        this.state.isExporting = false;
      });

      return true;
    }


    onEnter(e: any) {
      if (e.key === 'Enter') {
        this.submitSearch();
      }
    }

    getCasinoDescription(id: number) {
      return CommonsStore.casinoAllDescription(id) ? CommonsStore.casinoAllDescription(id).code : '';
    }

    getCasinoWithDaySales() {
      MyaaffiliateStore.GetCasinosWithDaySales(new Payload({
        affiliate_id: this.getAffiliateID,
      })).then((response: any) => {
        if (response.data) {
          this.activeCasinos = response.data;
        } else {
          this.activeCasinos = [];
        }
      });
    }

    /**
     * Computed
     * */

    get getCountry() {
        if (Array.isArray(this.playerCountry)) {
            return this.playerCountry.map(function(c) {
                return CountryStore.country(c.country) ? CountryStore.country(c.country) : '';
            });
        }

    }


    get columnFilters() {
      return [
        { id: this.DATE_COLUMN, label: this.$t('label.date') },
        { id: this.PLAYER_ID_COLUMN, label: `${this.$t('label.player_id')}` },
        { id: this.SIGNUP_COLUMN, label: this.$t('label.signups') },
        { id: this.FTD_COLUMN, label: `${this.$t('label.ftds')}` },
        { id: this.NGR_COLUMN, label: this.$t('label.net_revenue') },
        { id: this.DEPOSITS_COLUMN, label: `${this.$t('label.deposits')}` },
        { id: this.WITHDRAWALS_COLUMN, label: this.$t('label.withdrawals') },
        { id: this.COMMISSION_COLUMN, label: this.$t('label.commissions') },
      ];
    }

    get getAffiliateID() {
      let affiliate_id = AuthorizationStore.currentLoggedUserInState.id;
      if (affiliate_id === undefined || affiliate_id === null) {
        const local_json_string = localStorage.getItem('ma-auth.currentUser') as string;
        affiliate_id = JSON.parse(local_json_string).id;
      }

      return affiliate_id;
    }

    /**
     * Lifecycle hooks
     * */
    created() {
      this.getCasinoWithDaySales();
      this.submitSearch();
      CommonsStore.fetchAllCasino();
      CommonsStore.fetchPlayerCountry();
      window.addEventListener('keydown', this.onEnter); // will attach the event listener to the whole window when the component is created
    }

    beforeDestroy() {
      window.removeEventListener('keydown', this.onEnter); // will detach the event listener once the component is destroyed
    }

    beforeCreate() {
      this.dateUtils = {
        formatDate,
      };

      this.commonUtil = {
        toMoney,
      };
    }
}
